/*eslint-disable no-undef*/

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: config.PRIMARY_COLOR
            },
            light: {
                primary: config.PRIMARY_COLOR
            }
        }
    }
});
